import apiClient from "../utils/apiClient";
import {
  LOAD_ROLES_REQUEST,
  LOAD_ROLES_SUCCESS,
  LOAD_ROLES_FAIL,
  LOAD_ROLE_DETAIL_REQUEST,
  LOAD_ROLE_DETAIL_SUCCESS,
  LOAD_ROLE_DETAIL_FAIL,
  ADD_ROLE_REQUEST,
  ADD_ROLE_SUCCESS,
  ADD_ROLE_FAIL,
  UPDATE_ROLE_REQUEST,
  UPDATE_ROLE_SUCCESS,
  UPDATE_ROLE_FAIL,
  DELETE_ROLE_REQUEST,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_FAIL,
  SEED_ROLES_REQUEST,
  SEED_ROLES_SUCCESS,
  SEED_ROLES_FAIL,
  CLEAR_ROLE_ERRORS,
} from "../constants/roleConstants";

const API_PREFIX = process.env.REACT_APP_API_PREFIX || "";

// Get all roles (for the Roles management page - requires roles.view permission)
export const getRoles = () => async (dispatch) => {
  try {
    dispatch({ type: LOAD_ROLES_REQUEST });
    const { data } = await apiClient.get(`${API_PREFIX}/admin/roles`);
    dispatch({
      type: LOAD_ROLES_SUCCESS,
      payload: data.data,
    });
  } catch (err) {
    dispatch({
      type: LOAD_ROLES_FAIL,
      payload: err.response?.data?.errMessage || err.message,
    });
  }
};

// Get roles for dropdown (for user forms - any admin can access)
export const getRoleOptions = () => async (dispatch) => {
  try {
    dispatch({ type: LOAD_ROLES_REQUEST });
    const { data } = await apiClient.get(`${API_PREFIX}/admin/roles/options`);
    dispatch({
      type: LOAD_ROLES_SUCCESS,
      payload: data.data,
    });
  } catch (err) {
    dispatch({
      type: LOAD_ROLES_FAIL,
      payload: err.response?.data?.errMessage || err.message,
    });
  }
};

// Get single role detail
export const getRoleDetail = (id) => async (dispatch) => {
  try {
    dispatch({ type: LOAD_ROLE_DETAIL_REQUEST });
    const { data } = await apiClient.get(`${API_PREFIX}/admin/roles/${id}`);
    dispatch({
      type: LOAD_ROLE_DETAIL_SUCCESS,
      payload: data.data,
    });
  } catch (err) {
    dispatch({
      type: LOAD_ROLE_DETAIL_FAIL,
      payload: err.response?.data?.errMessage || err.message,
    });
  }
};

// Create a new role
export const createRole = (roleData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_ROLE_REQUEST });
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    const { data } = await apiClient.post(
      `${API_PREFIX}/admin/roles`,
      roleData,
      config
    );
    dispatch({
      type: ADD_ROLE_SUCCESS,
      payload: data.data,
    });
  } catch (err) {
    dispatch({
      type: ADD_ROLE_FAIL,
      payload: err.response?.data?.errMessage || err.message,
    });
  }
};

// Update a role
export const updateRole = (id, roleData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_ROLE_REQUEST });
    const config = {
      headers: { "Content-Type": "application/json" },
    };
    const { data } = await apiClient.put(
      `${API_PREFIX}/admin/roles/${id}`,
      roleData,
      config
    );
    dispatch({
      type: UPDATE_ROLE_SUCCESS,
      payload: data.data,
    });
  } catch (err) {
    dispatch({
      type: UPDATE_ROLE_FAIL,
      payload: err.response?.data?.errMessage || err.message,
    });
  }
};

// Delete a role
export const deleteRole = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_ROLE_REQUEST });
    await apiClient.delete(`${API_PREFIX}/admin/roles/${id}`);
    dispatch({
      type: DELETE_ROLE_SUCCESS,
      payload: id,
    });
  } catch (err) {
    dispatch({
      type: DELETE_ROLE_FAIL,
      payload: err.response?.data?.errMessage || err.message,
    });
  }
};

// Seed default roles
export const seedRoles = () => async (dispatch) => {
  try {
    dispatch({ type: SEED_ROLES_REQUEST });
    const { data } = await apiClient.post(`${API_PREFIX}/admin/roles/seed`);
    dispatch({
      type: SEED_ROLES_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: SEED_ROLES_FAIL,
      payload: err.response?.data?.errMessage || err.message,
    });
  }
};

// Clear errors
export const clearRoleErrors = () => (dispatch) => {
  dispatch({ type: CLEAR_ROLE_ERRORS });
};
